export default __webpack_public_path__ + "static/media/table-active.5140aa63.svg";